module.exports = __webpack_public_path__ + "img/sparkline-4.66a7cb3f.png";